import React from 'react';
import uniqid from 'uniqid';
import clsx from 'clsx';

import { createStyles } from "./styles";

var Toggle = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var checked = props.checked,onChange = props.onChange,labelActive = props.labelActive,labelInactive = props.labelInactive,name = props.name,_props$id = props.id,id = _props$id === void 0 ? uniqid() : _props$id,className = props.className;
  var classes = createStyles(props);
  return /*#__PURE__*/(
    React.createElement("label", {
      htmlFor: id,
      className: clsx(
      classes.toggleWrapper,
      checked ? classes.toggleChecked : classes.toggleUnchecked,
      className) }, /*#__PURE__*/


    React.createElement("input", {
      type: "checkbox",
      onChange: onChange,
      checked: checked,
      className: classes.checkbox,
      ref: ref,
      id: id,
      name: name }), /*#__PURE__*/

    React.createElement("span", {
      className: clsx(
      classes.labelText,
      checked ? classes.labelTextActive : classes.labelTextInactive) },


    checked ? labelActive : labelInactive)));



});
Toggle.displayName = 'Toggle';
export default Toggle;
//# sourceMappingURL=index.js.map